module.exports = __webpack_public_path__ + "img/File.21b3f70b.svg";